import { render, staticRenderFns } from "./ezBe.vue?vue&type=template&id=73460be2&scoped=true"
import script from "./ezBe.vue?vue&type=script&lang=js"
export * from "./ezBe.vue?vue&type=script&lang=js"
import style0 from "./ezBe.vue?vue&type=style&index=0&id=73460be2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73460be2",
  null
  
)

export default component.exports